/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./adv.vue?vue&type=template&id=20b13722&scoped=true"
import script from "./adv.vue?vue&type=script&lang=js"
export * from "./adv.vue?vue&type=script&lang=js"
import style0 from "./adv.vue?vue&type=style&index=0&id=20b13722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b13722",
  null
  
)

export default component.exports